import React, { memo, forwardRef } from "react";
const SvgRightSubscriptandSuperscript = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect
        width={11}
        height={19}
        x={5.5}
        y={6.5}
        stroke="#717171"
        strokeDasharray="2 2"
        strokeLinejoin="round"
        rx={1.5}
      />
      <rect width={8} height={12} x={19} y={17} fill="#DBDBDB" rx={2} />
      <rect width={8} height={12} x={19} y={3} fill="#DBDBDB" rx={2} />
    </svg>
  );
});
SvgRightSubscriptandSuperscript.displayName = "SvgRightSubscriptandSuperscript";
const MemoForwardRef = memo(SvgRightSubscriptandSuperscript);
export default MemoForwardRef;
